<template>
  <div>
    <span @click="search()">
      <Button
        type="primary"
        v-hasPermission="[
          'permissionsConfigurationManagement:menuManagement:create'
        ]"
        @click="menuManagementModal = true"
        >{{ $t("MenuManagement.addMenu") }}</Button
      >
    </span>
    <Modal
      v-model="menuManagementModal"
      title="添加菜单"
      :loading="loading"
      @on-ok="menuManagementSubmit('menuManagementForm')"
      @on-cancel="menuManagementReset('menuManagementForm')"
      :mask-closable="false"
    >
      <Form
        ref="menuManagementForm"
        :model="menuManagementForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 菜单角色 -->
        <FormItem label="菜单角色" prop="menuRole">
          <RadioGroup v-model="menuManagementForm.menuRole">
            <Radio
              v-for="list in menuRoleList"
              :label="list.label"
              :key="list.id"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <!-- 公司 -->
        <FormItem label="公司" prop="companyIds">
          <Select
            v-model="menuManagementForm.companyIds"
            filterable
            multiple
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompany()"
            style="width:200px"
          >
            <Option
              :value="item.id"
              v-for="(item, index) in companyList"
              :key="index"
              :disabled="item.disabled"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 类型 -->
        <FormItem label="类型" prop="menuType">
          <RadioGroup
            v-model="menuManagementForm.menuType"
            @on-change="changeMenuType(menuManagementForm.menuType)"
          >
            <Radio
              v-for="list in menuTypeList"
              :label="list.label"
              :key="list.name"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <!-- 上级菜单 -->
        <FormItem label="上级菜单">
          <Tree
            :data="menuData"
            :render="renderContent"
            @on-select-change="selectAll"
            ref="tree"
            style="height:180px;overflow-y: auto;"
          ></Tree>
        </FormItem>
        <div v-if="menuManagementForm.menuType === 'B'">
          <!-- 按钮名称 -->
          <FormItem label="按钮名称" prop="buttonName">
            <Input
              v-model="menuManagementForm.buttonName"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 权限标识 -->
          <FormItem label="权限标识" prop="perms">
            <Input
              v-model="menuManagementForm.perms"
              style="width:300px;"
            ></Input>
          </FormItem>
        </div>
        <div v-else>
          <!-- 菜单标题 -->
          <FormItem label="菜单标题" prop="title">
            <Input
              v-model="menuManagementForm.title"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 英文标题 -->
          <FormItem label="英文标题" prop="titleEnglish">
            <Input
              v-model="menuManagementForm.titleEnglish"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 菜单图标 -->
          <FormItem label="菜单图标" prop="icon">
            <Input
              v-model="menuManagementForm.icon"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 排序 -->
          <FormItem label="排序" prop="order">
            <Input
              v-model="menuManagementForm.order"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 地址栏路径 -->
          <FormItem label="地址栏路径" prop="path">
            <Input
              v-model="menuManagementForm.path"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 组件路径 -->
          <FormItem label="组件路径" prop="component">
            <Input
              v-model="menuManagementForm.component"
              style="width:300px;"
            ></Input>
          </FormItem>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import TableMenuManagement from "../menu_management/TableMenuManagement";
var tableMenuManagement = TableMenuManagement;
export default {
  data() {
    return {
      loading: true,
      menuId: "",
      menuManagementModal: false,
      menuTypeList: [
        {
          id: 0,
          label: "C",
          name: "目录"
        },
        {
          id: 1,
          label: "M",
          name: "菜单"
        },
        {
          id: 2,
          label: "B",
          name: "按钮"
        }
      ],
      menuManagementForm: {
        titleEnglish: "",
        title: "",
        order: "",
        path: "",
        menuType: "C",
        component: "",
        icon: "",
        buttonName: "",
        perms: "",
        menuRole: 0,
        companyIds: ""
      },
      menuRoleList: [
        {
          id: 0,
          label: 0,
          name: "普通菜单"
        },
        {
          id: 1,
          label: 1,
          name: "付费菜单"
        }
      ],
      companyList: [{ id: "0", name: "通用" }],
      ruleValidate: {
        companyIds: [
          {
            required: true,
            message: "请选择公司" // trigger: "change", // type: "array"
          }
        ],
        menuType: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
            type: "string"
          }
        ],
        title: [{ required: true, message: "请输入菜单标题", trigger: "blur" }],
        titleEnglish: [
          { required: true, message: "请输入英文标题", trigger: "blur" }
        ],
        order: [{ required: true, message: "请输入排序", trigger: "blur" }],
        path: [
          { required: true, message: "请输入地址栏路径", trigger: "blur" }
        ],
        component: [
          { required: true, message: "请输入组件路径", trigger: "blur" }
        ],
        icon: [{ required: false, message: "请输入菜单图标", trigger: "blur" }],
        buttonName: [
          { required: true, message: "请输入按钮名称", trigger: "blur" }
        ],
        perms: [{ required: true, message: "请输入权限标识", trigger: "blur" }]
      },
      menuData: [],
      selection: []
    };
  },
  mounted() {
    this.getCompanyDropDownBox();
  },
  watch: {
    "menuManagementForm.companyIds"(newVal, oldVal) {
      if (newVal.includes("0")) {
        this.companyList.forEach(item => (item.disabled = true));
        this.companyList[0].disabled = false;
        this.menuManagementForm.companyIds = this.companyList[0].id;
      } else {
        this.companyList.forEach(item => (item.disabled = false));
      }
    }
  },
  methods: {
    // 显示不同图标
    renderContent(h, { root, node, data }) {
      if (data.menuType == "B") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-radio-button-on"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      } else if (data.menuType == "C") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-bookmark"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      } else if (data.menuType == "M") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-grid"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      }
    },
    search: function() {
      if (this.menuManagementForm.companyIds.length == 0) {
        return;
      }
      this.$api.menu
        .menuTreeNode({
          companyId: this.menuManagementForm.companyIds,
          menuType: this.menuManagementForm.menuType
        })
        .then(res => {
          // 所有菜单数组
          this.menuData = res.data;
        });
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = this.companyList.concat(res.data);
          this.menuManagementForm.companyIds = this.companyList[0].id;
          this.companyList.forEach(element => {
            element.disabled = false;
          });
        });
    },
    changeCompany() {
      this.search();
    },
    // 切换菜单类型
    changeMenuType: function() {
      this.search();
    },
    selectAll: function(selection) {
      this.menuId = "";
      this.selection = selection;
      for (var i = 0; i < this.selection.length; i++) {
        this.menuId = this.selection[i].menuId;
      }
    },
    menuManagementSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 添加
          var menuDTO = {
            menuType: this.menuManagementForm.menuType
          };
          // 目录
          if (this.menuManagementForm.menuType == "C") {
            //如果parentId传给后端为空 后端parentId为0
            menuDTO.parentId = this.menuId;
            menuDTO.title = this.menuManagementForm.title;
            menuDTO.titleEn = this.menuManagementForm.titleEnglish;
            menuDTO.component = this.menuManagementForm.component;
            menuDTO.path = this.menuManagementForm.path;
            menuDTO.order = this.menuManagementForm.order;
            menuDTO.type = this.menuManagementForm.icon;
            menuDTO.menuRole = this.menuManagementForm.menuRole;
            menuDTO.companyIds = this.menuManagementForm.companyIds;
          } else if (this.menuManagementForm.menuType == "M") {
            //如果parentId传给后端为空 后端parentId为0
            menuDTO.parentId = this.menuId;
            menuDTO.title = this.menuManagementForm.title;
            menuDTO.titleEn = this.menuManagementForm.titleEnglish;
            menuDTO.component = this.menuManagementForm.component;
            menuDTO.path = this.menuManagementForm.path;
            menuDTO.order = this.menuManagementForm.order;
            menuDTO.type = this.menuManagementForm.icon;
            menuDTO.menuRole = this.menuManagementForm.menuRole;
            menuDTO.companyIds = this.menuManagementForm.companyIds;
          } else if (this.menuManagementForm.menuType == "B") {
            menuDTO.parentId = this.menuId;
            menuDTO.title = this.menuManagementForm.buttonName;
            menuDTO.perms = this.menuManagementForm.perms;
            menuDTO.menuRole = this.menuManagementForm.menuRole;
            menuDTO.companyIds = this.menuManagementForm.companyIds;
          }
          if (menuDTO.companyIds == 0) {
            menuDTO.companyIds = [0];
          }
          this.$api.menu.menuCreate(menuDTO).then(res => {
            setTimeout(() => {
              tableMenuManagement.methods.showAll();
              this.$refs[name].resetFields();
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.$Message.success("添加成功");
              this.menuId = "";
              this.selection = [];
              this.menuManagementModal = false;
              this.menuManagementForm.companyIds = this.companyList[0].id;
            }, 1000);
          });
        } else {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("添加失败");
        }
      });
    },
    menuManagementReset: function(name) {
      this.menuId = "";
      this.selection = [];
      this.$refs[name].resetFields();
      this.menuData = [];
      //   companyIds 重置为 默认第一个
      this.menuManagementForm.companyIds = this.companyList[0].id;
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/menu_management/AddMenuManagement.vue